import React from "react";

const Footer = () => {
  return <footer className=" w-full bg-black h-9  hidden md:flex items-center justify-center text-xs font-bold text-[#B3B3B3]">© 2026 Insurance Samadhan. All rights reserved.</footer>;
};

export default Footer;
